import React, { useState } from 'react';
import { useApi, api } from '../hooks/useApi';
import { useAuth } from '../context/AuthContext';
import useMobile from '../hooks/useMobile';
import { useTheme } from '../context/ThemeContext';

function fmtTime(iso) {
  if (!iso) return '–';
  return new Date(iso).toLocaleDateString('nb-NO', { weekday:'short', day:'numeric', month:'short', hour:'2-digit', minute:'2-digit' });
}

export default function DrivePage() {
  const isMobile = useMobile();
  const { dark } = useTheme();
  const { user, members } = useAuth();
  const { data: drives, refresh } = useApi('/api/drives');
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ title:'', person_id:'', driver_id:'', pickup_time:'', dropoff_time:'', location:'' });
  const [filter, setFilter] = useState('upcoming'); // upcoming | all

  const set = k => e => setForm(f => ({...f, [k]: e.target.value}));

  const save = async e => {
    e.preventDefault();
    await api.post('/api/drives', {
      ...form,
      pickup_time:  form.pickup_time  ? new Date(form.pickup_time).toISOString()  : null,
      dropoff_time: form.dropoff_time ? new Date(form.dropoff_time).toISOString() : null,
    });
    setShowForm(false);
    setForm({ title:'', person_id:'', driver_id:'', pickup_time:'', dropoff_time:'', location:'' });
    refresh();
  };

  const confirm = async id => { await api.put(`/api/drives/${id}/confirm`, {}); refresh(); };
  const del     = async id => { if (window.confirm('Slett kjøring?')) { await api.delete(`/api/drives/${id}`); refresh(); } };

  const now = new Date().toISOString();
  const shown = (drives||[]).filter(d => filter === 'all' || !d.pickup_time || d.pickup_time >= now);

  const pageBg = dark ? '#0A0818' : '#EDE8FF';
  const txt    = dark ? '#E8E8F8' : '#1A1A35';
  const sub    = dark ? '#9090B8' : '#888';
  const glassInp = { padding:'12px 14px', borderRadius:12, border:'1px solid '+(dark?'rgba(255,255,255,0.12)':'rgba(124,111,247,0.2)'), background: dark?'rgba(255,255,255,0.08)':'rgba(255,255,255,0.7)', color:txt, fontSize:14, fontFamily:'inherit', outline:'none' };

  if (isMobile) return (
    <div style={{ background:pageBg, minHeight:'100%', fontFamily:"'Plus Jakarta Sans',sans-serif" }}>

      {/* Gradient Hero Header */}
      <div style={{
        background: dark
          ? 'linear-gradient(145deg, #2D1B69 0%, #1A1245 55%, #0D0B1E 100%)'
          : 'linear-gradient(145deg, #7C6FF7 0%, #9358E8 45%, #5E4AE3 100%)',
        padding: '52px 20px 20px',
        position: 'relative',
        overflow: 'hidden',
      }}>
        <div style={{ position:'absolute', top:-40, right:-40, width:160, height:160, borderRadius:'50%', background:'rgba(255,255,255,0.06)', pointerEvents:'none' }}/>
        <div style={{ position:'absolute', bottom:-60, left:-20, width:140, height:140, borderRadius:'50%', background:'rgba(255,255,255,0.04)', pointerEvents:'none' }}/>
        <div style={{ position:'relative', zIndex:1 }}>
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:14 }}>
            <div>
              <div style={{ fontSize:13, color:'rgba(255,255,255,0.65)', fontWeight:500, marginBottom:2 }}>Famora</div>
              <div style={{ fontSize:24, fontWeight:800, color:'#fff' }}>Kjøring</div>
            </div>
            <button onClick={()=>setShowForm(v=>!v)} style={{ background:'rgba(255,255,255,0.15)', backdropFilter:'blur(10px)', color:'#fff', border:'1px solid rgba(255,255,255,0.25)', borderRadius:12, padding:'8px 16px', fontWeight:700, fontSize:14, cursor:'pointer' }}>
              {showForm?'Avbryt':'+ Ny'}
            </button>
          </div>
          {/* Filter chips */}
          <div style={{ display:'flex', gap:6 }}>
            {['upcoming','all'].map(t=>(
              <button key={t} onClick={()=>setFilter(t)} style={{ padding:'7px 16px', borderRadius:20, border:'none', background:filter===t?'rgba(255,255,255,0.9)':'rgba(255,255,255,0.15)', color:filter===t?'#7C6FF7':'rgba(255,255,255,0.85)', fontWeight:700, fontSize:13, cursor:'pointer' }}>
                {t==='upcoming'?'Kommende':'Alle'}
              </button>
            ))}
          </div>
        </div>
      </div>

      {showForm && (
        <form onSubmit={save} className="glass-card" style={{ margin:'12px 16px', padding:14, display:'flex', flexDirection:'column', gap:10 }}>
          <input style={{...glassInp, width:'100%', boxSizing:'border-box'}} placeholder="Hva (f.eks. Fotballtrening)" value={form.title} onChange={set('title')} required/>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
            <select style={{...glassInp, padding:'11px 12px'}} value={form.person_id} onChange={set('person_id')}>
              <option value="">Passasjer</option>
              {members.map(m=><option key={m.id} value={m.id}>{m.name}</option>)}
            </select>
            <select style={{...glassInp, padding:'11px 12px'}} value={form.driver_id} onChange={set('driver_id')}>
              <option value="">Sjåfør</option>
              {members.map(m=><option key={m.id} value={m.id}>{m.name}</option>)}
            </select>
          </div>
          <input type="datetime-local" style={{...glassInp, padding:'11px 14px'}} value={form.pickup_time} onChange={set('pickup_time')}/>
          <input style={{...glassInp, width:'100%', boxSizing:'border-box'}} placeholder="Sted" value={form.location} onChange={set('location')}/>
          <button type="submit" style={{ background:'linear-gradient(135deg,#7C6FF7,#9358E8)', color:'#fff', border:'none', borderRadius:12, padding:13, fontWeight:700, fontSize:15, cursor:'pointer' }}>Legg til kjøring</button>
        </form>
      )}

      <div style={{ padding:'12px 16px 80px' }}>
        {shown.length===0 && (
          <div style={{ textAlign:'center', padding:'60px 20px', color:sub }}>
            <div style={{ fontSize:48, marginBottom:12 }}>🚗</div>
            <div style={{ fontSize:16, fontWeight:700, color:txt }}>Ingen kjøringer</div>
          </div>
        )}
        {shown.map(d => (
          <div key={d.id} className="glass-card" style={{ marginBottom:8, padding:'14px 16px' }}>
            <div style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:15, fontWeight:700, color:txt, marginBottom:4 }}>{d.title}</div>
                {d.pickup_time && <div style={{ fontSize:13, color:sub, marginBottom:2 }}>📅 {fmtTime(d.pickup_time)}</div>}
                {d.location && <div style={{ fontSize:13, color:sub, marginBottom:2 }}>📍 {d.location}</div>}
                <div style={{ fontSize:12, color:sub, marginTop:4, display:'flex', gap:10 }}>
                  {d.person_name && <span>👤 {d.person_name}</span>}
                  {d.driver_name && <span>🚗 {d.driver_name}</span>}
                </div>
              </div>
              <div style={{ display:'flex', flexDirection:'column', alignItems:'flex-end', gap:6 }}>
                <span style={{ fontSize:11, fontWeight:700, padding:'3px 10px', borderRadius:20, background:d.status==='confirmed'?'rgba(52,211,153,0.15)':'rgba(251,191,36,0.15)', color:d.status==='confirmed'?'#34D399':'#FBBF24' }}>
                  {d.status==='confirmed'?'✓ Bekreftet':'Venter'}
                </span>
                <div style={{ display:'flex', gap:6 }}>
                  {d.status!=='confirmed' && <button onClick={()=>confirm(d.id)} style={{ background:'rgba(52,211,153,0.15)', color:'#34D399', border:'none', borderRadius:8, padding:'5px 10px', fontSize:12, fontWeight:700, cursor:'pointer' }}>Bekreft</button>}
                  <button onClick={()=>del(d.id)} style={{ background:'rgba(247,96,92,0.15)', color:'#F7605C', border:'none', borderRadius:8, padding:'5px 10px', fontSize:12, fontWeight:700, cursor:'pointer' }}>Slett</button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div style={s.wrap}>
      <div style={s.toolbar}>
        <div style={s.tabs}>
          {['upcoming','all'].map(t => (
            <button key={t} style={{...s.tab, ...(filter===t?s.tabActive:{})}} onClick={() => setFilter(t)}>
              {t === 'upcoming' ? 'Kommende' : 'Alle'}
            </button>
          ))}
        </div>
        <button style={s.newBtn} onClick={() => setShowForm(v=>!v)}>+ Ny kjøring</button>
      </div>

      {showForm && (
        <div style={s.formCard}>
          <div style={s.formTitle}>Ny kjøring</div>
          <form onSubmit={save} style={s.form}>
            <input style={s.inp} placeholder="Hva (f.eks. Fotballtrening)" value={form.title} onChange={set('title')} required />
            <div style={s.row}>
              <div style={s.field}>
                <label style={s.lbl}>Passasjer</label>
                <select style={s.sel} value={form.person_id} onChange={set('person_id')}>
                  <option value="">Ikke valgt</option>
                  {members.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
                </select>
              </div>
              <div style={s.field}>
                <label style={s.lbl}>Sjåfør</label>
                <select style={s.sel} value={form.driver_id} onChange={set('driver_id')}>
                  <option value="">Ikke bestemt</option>
                  {members.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
                </select>
              </div>
            </div>
            <div style={s.row}>
              <div style={s.field}>
                <label style={s.lbl}>Henting</label>
                <input style={s.inp} type="datetime-local" value={form.pickup_time} onChange={set('pickup_time')} />
              </div>
              <div style={s.field}>
                <label style={s.lbl}>Levering</label>
                <input style={s.inp} type="datetime-local" value={form.dropoff_time} onChange={set('dropoff_time')} />
              </div>
            </div>
            <input style={s.inp} placeholder="Sted / adresse" value={form.location} onChange={set('location')} />
            <div style={{display:'flex',gap:8}}>
              <button style={s.saveBtn} type="submit">Lagre</button>
              <button style={s.cancelBtn} type="button" onClick={() => setShowForm(false)}>Avbryt</button>
            </div>
          </form>
        </div>
      )}

      {shown.length === 0 && <div style={s.empty}>Ingen kjøringer å vise</div>}

      {shown.map(d => (
        <div key={d.id} style={{...s.card, ...(d.confirmed?s.cardConfirmed:{})}}>
          <div style={s.cardTop}>
            <div style={s.cardTitle}>{d.title}</div>
            {d.confirmed
              ? <span style={s.badge}>✅ Bekreftet</span>
              : <span style={{...s.badge, ...s.badgePending}}>⏳ Venter</span>
            }
          </div>
          <div style={s.meta}>
            {d.person_name  && <span>👤 {d.person_name}</span>}
            {d.driver_name  && <span>🚗 {d.driver_name}</span>}
            {d.pickup_time  && <span>🕐 {fmtTime(d.pickup_time)}</span>}
            {d.dropoff_time && <span>🏁 {fmtTime(d.dropoff_time)}</span>}
            {d.location     && <span>📍 {d.location}</span>}
          </div>
          <div style={s.cardActions}>
            {!d.confirmed && (
              <button style={s.confirmBtn} onClick={() => confirm(d.id)}>
                Jeg kjører
              </button>
            )}
            <button style={s.delBtn} onClick={() => del(d.id)}>Slett</button>
          </div>
        </div>
      ))}
    </div>
  );
}

const s = {
  wrap:          { display:'flex', flexDirection:'column', gap:12 },
  toolbar:       { display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:8 },
  tabs:          { display:'flex', gap:4, background:'#fff', padding:4, borderRadius:10, border:'1px solid #EAE8F8' },
  tab:           { padding:'6px 14px', borderRadius:8, border:'none', background:'transparent', color:'#6B6B8A', fontWeight:600, cursor:'pointer', fontSize:13, fontFamily:'inherit' },
  tabActive:     { background:'#7C6FF7', color:'#fff' },
  newBtn:        { padding:'9px 16px', borderRadius:10, border:'none', background:'#7C6FF7', color:'#fff', fontWeight:700, cursor:'pointer', fontSize:13, fontFamily:'inherit' },
  formCard:      { background:'#fff', borderRadius:16, padding:18, border:'1px solid #EAE8F8' },
  formTitle:     { fontSize:15, fontWeight:800, color:'#1A1A35', marginBottom:14 },
  form:          { display:'flex', flexDirection:'column', gap:10 },
  row:           { display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 },
  field:         { display:'flex', flexDirection:'column', gap:4 },
  lbl:           { fontSize:11, fontWeight:700, color:'#6B6B8A', textTransform:'uppercase', letterSpacing:.4 },
  inp:           { padding:'9px 12px', borderRadius:9, border:'1px solid #EAE8F8', fontFamily:'inherit', fontSize:13, color:'#1A1A35', outline:'none' },
  sel:           { padding:'9px 12px', borderRadius:9, border:'1px solid #EAE8F8', fontFamily:'inherit', fontSize:13, color:'#1A1A35', outline:'none', background:'#fff' },
  saveBtn:       { flex:1, padding:'9px', borderRadius:9, border:'none', background:'#7C6FF7', color:'#fff', fontWeight:700, cursor:'pointer', fontSize:13, fontFamily:'inherit' },
  cancelBtn:     { flex:1, padding:'9px', borderRadius:9, border:'1px solid #EAE8F8', background:'#fff', color:'#6B6B8A', fontWeight:600, cursor:'pointer', fontSize:13, fontFamily:'inherit' },
  empty:         { color:'#A0A0B8', fontSize:14, padding:'30px 0', textAlign:'center' },
  card:          { background:'#fff', borderRadius:14, padding:'14px 16px', border:'1px solid #EAE8F8' },
  cardConfirmed: { borderColor:'#34D399', background:'#F0FDF4' },
  cardTop:       { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 },
  cardTitle:     { fontSize:15, fontWeight:800, color:'#1A1A35' },
  badge:         { fontSize:11, fontWeight:700, background:'#D1FAE5', color:'#065F46', padding:'3px 8px', borderRadius:20 },
  badgePending:  { background:'#FEF3C7', color:'#92400E' },
  meta:          { display:'flex', flexWrap:'wrap', gap:'4px 14px', fontSize:13, color:'#6B6B8A', marginBottom:10 },
  cardActions:   { display:'flex', gap:8 },
  confirmBtn:    { padding:'7px 16px', borderRadius:9, border:'none', background:'#34D399', color:'#fff', fontWeight:700, cursor:'pointer', fontSize:13, fontFamily:'inherit' },
  delBtn:        { padding:'7px 16px', borderRadius:9, border:'1px solid #EAE8F8', background:'#fff', color:'#F7605C', fontWeight:700, cursor:'pointer', fontSize:13, fontFamily:'inherit' },
};
